export default {
  path: '/storeMasterData',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'firstLevel',
      name: 'firstLevel',
      component: () => import('@/pages/masterData/storeMasterData/FirstLevelStore/index.vue'),
      meta: {
        keepAlive: true,
        title: '一级列表',
      },
    },
    {
      path: 'addStore',
      name: 'addStore',
      component: () =>
        import('@/pages/masterData/storeMasterData/FirstLevelStore/pages/addStore.vue'),
      meta: {
        keepAlive: true,
        title: '仓库一级新建',
      },
    },
    {
      path: 'firstLevelDetail',
      name: 'firstLevelDetail',
      component: () =>
        import('@/pages/masterData/storeMasterData/FirstLevelStore/pages/Detail.vue'),
      meta: {
        keepAlive: true,
        title: '编辑仓库',
      },
    },
    {
      path: 'secondLevel',
      name: 'secondLevel',
      component: () => import('@/pages/masterData/storeMasterData/SecondLevelStore/index.vue'),
      meta: {
        keepAlive: true,
        title: '二级列表',
      },
    },
    {
      path: 'secondLevelDetail',
      name: 'secondLevelDetail',
      component: () =>
        import('@/pages/masterData/storeMasterData/SecondLevelStore/pages/Detail.vue'),
      meta: {
        keepAlive: true,
        title: '仓库二级新建',
      },
    },
    {
      path: 'threeLevel',
      name: 'threeLevel',
      component: () => import('@/pages/masterData/storeMasterData/ThreeLevelStore/index.vue'),
      meta: {
        keepAlive: true,
        title: '三级列表',
      },
    },
    {
      path: 'threeLevelDetail',
      name: 'threeLevelDetail',
      component: () =>
        import('@/pages/masterData/storeMasterData/ThreeLevelStore/pages/Detail.vue'),
      meta: {
        keepAlive: true,
        title: '仓库三级新建',
      },
    },
    {
      path: 'fourLevel',
      name: 'fourLevel',
      component: () => import('@/pages/masterData/storeMasterData/FourLevelStore/index.vue'),
      meta: {
        keepAlive: true,
        title: '四级列表',
      },
    },
    {
      path: 'fourLevelDetail',
      name: 'fourLevelDetail',
      component: () => import('@/pages/masterData/storeMasterData/FourLevelStore/pages/Detail.vue'),
      meta: {
        keepAlive: true,
        title: '仓库四级新建',
      },
    },
  ],
};
